import { useEffect, useState, useCallback } from 'react';

const detectPlatform = () => {
  const ua = window.navigator.userAgent || window.navigator.vendor || '';

  const isIOS = (/iPad|iPhone|iPod/.test(ua) && !window.MSStream)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) {
    const isChromeOnIos = /CriOS/.test(ua);
    const isFirefoxOnIos = /FxiOS/.test(ua);
    return {
      platform: 'ios',
      isSafari: !isChromeOnIos && !isFirefoxOnIos,
    };
  }

  if (/android/i.test(ua)) {
    return { platform: 'android', isSafari: false };
  }

  return { platform: 'desktop', isSafari: false };
};

export const usePwaInstall = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(
    window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
  );
  const [{ platform, isSafari }] = useState(detectPlatform);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    const handleAppInstalled = () => {
      setDeferredPrompt(null);
      setIsInstalled(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferredPrompt) return false;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    return outcome === 'accepted';
  }, [deferredPrompt]);

  return {
    canInstall: !!deferredPrompt && !isInstalled,
    isInstalled,
    promptInstall,
    platform,
    isSafari,
  };
};
